import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, Link, useNavigate } from 'react-router-dom';
import { Menu as MenuIcon, X as XIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);
  // Function to scroll with proper offset
  const scrollWithOffset = (el: HTMLElement) => {
    const header = document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 0;
    const elementPosition = el.offsetTop;
    const offsetPosition = elementPosition - headerHeight - 20;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  };
  // Function to scroll to top of page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  // Handle navigation with scrolling to top
  const handleNavigation = (path: string) => {
    if (location.pathname === path) {
      // If already on the page, just scroll to top
      scrollToTop();
    } else {
      // Navigate to the new page
      navigate(path);
      // Ensure scroll happens after navigation
      window.scrollTo(0, 0);
    }
    // Close mobile menu if open
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };
  const navItems = [{
    name: 'HOME',
    path: '/'
  }, {
    name: 'BIOGRAPHY',
    path: '/biography'
  }, {
    name: 'UNIVERSE',
    path: '/universe'
  }, {
    name: 'VISUALISERS',
    path: '/visualisers'
  }, {
    name: 'IMAGES',
    path: '/images'
  }, {
    name: 'LYRICS',
    path: '/lyrics'
  }, {
    name: 'LIVE',
    path: '/live'
  }, {
    name: 'MERCH',
    path: '/merch'
  }, {
    name: 'CONNECT',
    path: '/connect'
  }, {
    name: 'TIMELINE',
    path: '/timeline'
  }];
  return <header className={`fixed top-0 left-0 right-0 w-full z-30 transition-all duration-500 ${scrolled ? 'bg-black/80 backdrop-blur-md py-3 shadow-lg shadow-pink-500/10' : 'bg-transparent py-4 sm:py-8'}`} data-id="element-230">
      <div className="container mx-auto px-4 sm:px-6 max-w-full" data-id="element-231">
        <div className="flex justify-between items-center" data-id="element-232">
          <div className="flex flex-col" data-id="element-233">
            <Link to="/" className="text-decoration-none" onClick={e => {
            if (location.pathname === '/') {
              e.preventDefault();
              scrollToTop();
            }
          }} data-id="element-234">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 font-mono glitch-text" data-id="element-235">
                FABRIC REALITY
              </h1>
              <p className="text-xs md:text-sm tracking-[0.3em] text-pink-300/80 font-mono" data-id="element-236">
                INTERSTELLAR ROCK MUSIC
              </p>
            </Link>
          </div>
          <button className="lg:hidden text-white focus:outline-none" onClick={toggleMenu} aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-237">
            {isMenuOpen ? <XIcon size={28} data-id="element-238" /> : <MenuIcon size={28} data-id="element-239" />}
          </button>
          <nav className="hidden lg:block" data-id="element-240">
            <ul className="flex space-x-4 lg:space-x-6 font-mono text-sm lg:text-base overflow-x-auto hide-scrollbar" data-id="element-241">
              {navItems.map((item, index) => <li key={index} data-id="element-242">
                  <button onClick={() => handleNavigation(item.path)} className={`relative px-2 py-1 transition-all duration-300 ${location.pathname === item.path ? "text-pink-400 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-gradient-to-r after:from-pink-500 after:to-purple-500" : 'text-gray-300 hover:text-pink-300'}`} data-id="element-243">
                    <span className="hover:glitch-hover" data-id="element-244">{item.name}</span>
                  </button>
                </li>)}
            </ul>
          </nav>
        </div>
        {/* Tablet/Mobile Navigation Menu */}
        {isMenuOpen && <div className="lg:hidden mt-6" data-id="element-245">
            <nav className="bg-black/90 backdrop-blur-lg rounded-2xl p-5 border border-purple-500/20 shadow-lg shadow-purple-500/10" data-id="element-246">
              <ul className="flex flex-col space-y-4 font-mono text-lg" data-id="element-247">
                {navItems.map((item, index) => <li key={index} className="border-b border-purple-500/10 last:border-b-0" data-id="element-248">
                    <button onClick={() => handleNavigation(item.path)} className={`block w-full text-left px-2 py-3 transition-all duration-300 ${location.pathname === item.path ? 'text-pink-400 border-l-2 border-pink-500 pl-3' : 'text-gray-300 hover:text-pink-300'}`} data-id="element-249">
                      {item.name}
                    </button>
                  </li>)}
              </ul>
            </nav>
          </div>}
      </div>
    </header>;
};
export default Header;